import { createSharedData } from "components/Share";

import { IEReservationContext } from "../types/IEReservationContext";

const {
  ShareProvider,
  useShareConsumer,
} = createSharedData<IEReservationContext>();

export {
  useShareConsumer as useContextConsumer,
  ShareProvider as ContextProvider,
};
